export default __webpack_public_path__ + "static/media/Mask Group 7.79f2cbbf.png";